import { useQuery } from '@apollo/client';
import queries from '../../graphql-queries/reflection';

export function useReflections() {
  const { loading, error, data } = useQuery(queries.GET_REFLECTIONS, {
    fetchPolicy: 'cache-and-network'
  });
  return { loading, data, error };
}
